import {
  HTTP_INTERCEPTORS,
  HttpEvent,
  HttpHandler,
  HttpHeaders,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SETTING_KEYS } from '@constants/settings';
import { PermissionsService } from '@services/permissions.service';
import { getStorage } from '@utils/helper';
import { Observable } from 'rxjs';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private isRefreshing = false;
  constructor(private permissionService: PermissionsService) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (!getStorage(SETTING_KEYS.jwt)) {
      return next.handle(request);
    }
    return next.handle(this.addTokenHeader(request));
  }

  private addTokenHeader(request: HttpRequest<any>) {
    let headers = new HttpHeaders();
    headers = headers.set('Authorization', `Bearer ${getStorage(SETTING_KEYS.jwt)}`);
    return request.clone({
      headers,
    });
  }
}

export const authInterceptor = { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true };
